(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const values = document.querySelectorAll('.about-us__value');
    const button = document.querySelector('.about-us__values-button');
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -50px 0px' });
    values.forEach(function(v) { observer.observe(v); });
    if (button) observer.observe(button);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-product-info"]) return;
  try {
    
  (function () {
    // Store current dome options per section so panel changes can still look them up
    var bundleDomeOptions = {};

    function updateBundleImage(sectionId, domeOptions) {
      var panelSelector = document.getElementById('bundle-panel-selector-' + sectionId);
      if (!panelSelector) return;

      // Use passed-in options (from variantChange event) or fall back to last known
      if (domeOptions) bundleDomeOptions[sectionId] = domeOptions;
      var options = bundleDomeOptions[sectionId];
      if (!options) return;

      var color = null, size = null;
      options.forEach(function (val) {
        var v = val.toLowerCase();
        if (v === 'black' || v === 'white') color = v;
        if (v === 'standard' || v === 'xl') size = v;
      });

      var checkedPanel = panelSelector.querySelector('input[type="radio"]:checked');
      if (!checkedPanel) return;
      var panelKeys = ['rn60', 'rn300', 'rn1200'];
      var panelIndex = parseInt(checkedPanel.dataset.panelIndex, 10);
      var panelText = panelKeys[panelIndex];

      if (!color || !size || !panelText) return;

      var key = 'bundle-' + color + '-' + size + '-' + panelText;

      var mapEl = document.getElementById('bundle-media-map-' + sectionId);
      if (!mapEl) return;
      var mediaList;
      try { mediaList = JSON.parse(mapEl.textContent); } catch (e) { return; }

      // Build alt → [id, id, ...] lookup (supports multiple images per alt)
      var altToIds = {};
      mediaList.forEach(function (pair) {
        var alt = pair[0], id = pair[1];
        if (!altToIds[alt]) altToIds[alt] = [];
        altToIds[alt].push(id);
      });

      var bundleIds = altToIds[key] || [];
      var targetId = bundleIds.length ? sectionId + '-' + bundleIds[0] : null;

      // All bundle-* image IDs
      var allBundleIds = {};
      Object.keys(altToIds).forEach(function (alt) {
        if (alt.indexOf('bundle-') === 0) {
          altToIds[alt].forEach(function (id) {
            allBundleIds[sectionId + '-' + id] = true;
          });
        }
      });

      // All panel image IDs, and matching panel IDs
      var allPanelIds = {};
      var matchingPanelIds = {};
      ['rn60', 'rn300', 'rn1200'].forEach(function (panel) {
        (altToIds[panel] || []).forEach(function (id) {
          var tid = sectionId + '-' + id;
          allPanelIds[tid] = panel;
          if (panel === panelText) matchingPanelIds[tid] = true;
        });
      });

      // Main gallery
      var gallery = document.querySelector('#MainProduct-' + sectionId + ' .product__media-list');
      if (!gallery) return;
      var activeItem = null;
      gallery.querySelectorAll('.product__media-item').forEach(function (item) {
        var mid = item.dataset.mediaId;
        var isBundleImage = allBundleIds[mid];
        var isPanelImage = allPanelIds[mid] !== undefined;
        var isBundleMatch = mid === targetId;
        var isPanelMatch = matchingPanelIds[mid];

        if ((isBundleImage && !isBundleMatch) || (isPanelImage && !isPanelMatch)) {
          item.style.display = 'none';
        } else {
          item.style.display = '';
          item.classList.toggle('is-active', isBundleMatch);
          if (isBundleMatch) activeItem = item;
        }
      });

      // On mobile, the gallery is a slider — scroll it to the active image
      if (activeItem && targetId) {
        var mediaGallery = document.querySelector('media-gallery[id="MediaGallery-' + sectionId + '"], #MainProduct-' + sectionId + ' media-gallery');
        if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
          var rawMediaId = targetId.replace(sectionId + '-', '');
          mediaGallery.setActiveMedia(targetId, false);
        } else {
          // Fallback: scroll the slider list to the active item
          gallery.scrollTo({ left: activeItem.offsetLeft, behavior: 'smooth' });
        }
      }

      // Thumbnail list
      var thumbList = document.querySelector('#GalleryThumbnails-' + sectionId + ' .thumbnail-list') ||
                      document.querySelector('#MainProduct-' + sectionId + ' .thumbnail-list');
      if (thumbList) {
        thumbList.querySelectorAll('.thumbnail-list__item').forEach(function (thumb) {
          var t = thumb.dataset.target || thumb.dataset.mediaId;
          if (!t) return;
          var isBundleImage = allBundleIds[t];
          var isPanelImage = allPanelIds[t] !== undefined;
          var isBundleMatch = t === targetId;
          var isPanelMatch = matchingPanelIds[t];

          if ((isBundleImage && !isBundleMatch) || (isPanelImage && !isPanelMatch)) {
            thumb.style.display = 'none';
          } else {
            thumb.style.display = '';
          }
        });
      }


    }

    function updateBundlePrice(sectionId, domeOptions) {
      var priceMapEl = document.getElementById('bundle-price-map-' + sectionId);
      var domePricesEl = document.getElementById('bundle-dome-prices-' + sectionId);
      var panelPricesEl = document.getElementById('bundle-panel-prices-' + sectionId);
      if (!priceMapEl || !domePricesEl || !panelPricesEl) return;

      var bundlePriceMap, domePrices, panelPrices;
      try {
        bundlePriceMap = JSON.parse(priceMapEl.textContent);
        domePrices = JSON.parse(domePricesEl.textContent);
        panelPrices = JSON.parse(panelPricesEl.textContent);
      } catch (e) { return; }

      if (domeOptions) bundleDomeOptions[sectionId] = domeOptions;
      var options = bundleDomeOptions[sectionId];
      if (!options) return;

      var color = null, size = null;
      options.forEach(function (val) {
        var v = val.toLowerCase();
        if (v === 'black' || v === 'white') color = v;
        if (v === 'standard' || v === 'xl') size = v;
      });

      var panelSelector = document.getElementById('bundle-panel-selector-' + sectionId);
      if (!panelSelector) return;
      var checkedPanel = panelSelector.querySelector('input[type="radio"]:checked');
      if (!checkedPanel) return;
      var panelKeys = ['rn60', 'rn300', 'rn1200'];
      var panelIndex = parseInt(checkedPanel.dataset.panelIndex, 10);
      var panelText = panelKeys[panelIndex];

      if (!color || !size || !panelText) return;

      var key = color + '-' + size + '-' + panelText;
      var bundlePrice = bundlePriceMap[key];
      if (!bundlePrice) return;

      // Original price = dome + panel + stand (if RN300)
      var domeKey = color + '-' + size;
      var domePrice = domePrices[domeKey] || null;
      var panelVariantId = checkedPanel.dataset.variantId;
      var panelPrice = panelVariantId ? panelPrices[String(panelVariantId)] : null;
      var standPrice = 0;
      if (panelIndex === 1) {
        var standPriceEl = document.getElementById('bundle-stand-price-' + sectionId);
        if (standPriceEl) standPrice = parseInt(standPriceEl.value, 10) || 0;
      }
      var originalPrice = (domePrice && panelPrice) ? domePrice + panelPrice + standPrice : null;

      function formatMoney(cents) {
        return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      }

      var currentEl = document.getElementById('bundle-price-current-' + sectionId);
      var compareEl = document.getElementById('bundle-price-compare-' + sectionId);
      var originalEl = document.getElementById('bundle-price-original-' + sectionId);

      if (currentEl) currentEl.textContent = formatMoney(bundlePrice);

      if (originalPrice && originalPrice > bundlePrice) {
        if (originalEl) {
          originalEl.textContent = formatMoney(originalPrice);
          originalEl.style.display = '';
        }
        if (compareEl) {
          compareEl.textContent = 'Save ' + formatMoney(originalPrice - bundlePrice) + '!';
          compareEl.style.display = '';
        }
      } else {
        if (originalEl) originalEl.style.display = 'none';
        if (compareEl) compareEl.style.display = 'none';
      }

      var bundlePaymentVariantEl = document.getElementById('bundle-payment-variant-' + sectionId);
      if (bundlePaymentVariantEl && bundlePrice) {
        var shopPayTerms = document.querySelector('#bundle-payment-form-' + sectionId + ' shopify-payment-terms');
        if (shopPayTerms) {
          shopPayTerms.setAttribute('data-price', bundlePrice);
          shopPayTerms.dispatchEvent(new CustomEvent('change'));
        }
      }
    }

    function initBundleBuyButtons(sectionId) {
      var btn = document.getElementById('bundle-add-to-cart-' + sectionId);
      if (!btn) return;

      btn.addEventListener('click', function () {
        var items = [];

        // Dome variant: read from variant-selects data-selected-variant (always reflects current selection)
        var variantSelects = document.querySelector('#variant-selects-' + sectionId);
        if (variantSelects) {
          var selectedVariantEl = variantSelects.querySelector('[data-selected-variant]');
          if (selectedVariantEl && selectedVariantEl.textContent.trim()) {
            try {
              var selectedVariant = JSON.parse(selectedVariantEl.textContent);
              if (selectedVariant && selectedVariant.id) {
                items.push({ id: selectedVariant.id, quantity: 1 });
              }
            } catch (e) {}
          }
        }
        // Fallback to the dedicated hidden input initialized with dome's first variant
        if (items.length === 0) {
          var domeInput = document.getElementById('bundle-dome-variant-' + sectionId);
          if (domeInput && domeInput.value) {
            items.push({ id: parseInt(domeInput.value, 10), quantity: 1 });
          }
        }

        // Panel variant + optional addon: read from the checked radio in the panel selector
        var panelSelector = document.getElementById('bundle-panel-selector-' + sectionId);
        if (panelSelector) {
          var checkedPanel = panelSelector.querySelector('input[type="radio"]:checked');
          if (checkedPanel && checkedPanel.dataset.variantId) {
            items.push({ id: parseInt(checkedPanel.dataset.variantId, 10), quantity: 1 });
          }
          if (checkedPanel && parseInt(checkedPanel.dataset.panelIndex, 10) === 1) {
            var standInput = document.getElementById('bundle-stand-variant-' + sectionId);
            if (standInput && standInput.value) {
              items.push({ id: parseInt(standInput.value, 10), quantity: 1 });
            }
          }
        }

        if (items.length === 0) return;

        var originalText = btn.querySelector('span').textContent;
        btn.disabled = true;
        btn.querySelector('span').textContent = 'Adding...';

        var cartDrawer = document.querySelector('cart-drawer');

        var formData = new FormData();
        items.forEach(function (item) {
          formData.append('items[][id]', item.id);
          formData.append('items[][quantity]', item.quantity);
        });
        if (cartDrawer) {
          cartDrawer.getSectionsToRender().forEach(function (s) {
            formData.append('sections[]', s.id);
          });
          formData.append('sections_url', window.location.pathname);
          cartDrawer.setActiveElement(document.activeElement);
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            btn.disabled = false;
            btn.querySelector('span').textContent = originalText;
            if (data.status) {
              console.error('Cart add error:', data.description);
              return;
            }
            if (cartDrawer) {
              cartDrawer.classList.remove('is-empty');
              cartDrawer.renderContents(data);
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function () {
            btn.disabled = false;
            btn.querySelector('span').textContent = originalText;
          });
      });
    }

    function initBundleImageSwap(sectionId) {
      // Override updateMedia so Shopify's variant JS doesn't swap images
      var productInfo = document.getElementById('MainProduct-' + sectionId);
      if (productInfo) productInfo.updateMedia = function () {};

      // Seed initial dome options from the embedded selected-variant JSON
      var variantSelects = document.querySelector('#variant-selects-' + sectionId);
      if (variantSelects) {
        var initialJson = variantSelects.querySelector('[data-selected-variant]');
        if (initialJson) {
          try {
            var initialVariant = JSON.parse(initialJson.textContent);
            if (initialVariant && initialVariant.options) {
              bundleDomeOptions[sectionId] = initialVariant.options;
            }
          } catch (e) {}
        }
      }

      // Subscribe to optionValueSelectionChange — fires instantly on click, before any fetch
      // selectedOptionValues is an array of the currently selected option value elements
      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (event) {
        var target = event.data && event.data.target;
        if (!target) return;
        // Check this event belongs to our section's variant-selects
        var selects = target.closest('#variant-selects-' + sectionId);
        if (!selects) return;
        // Read all checked radio values right now — they're already updated
        var options = [];
        selects.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
          options.push(input.value);
        });
        updateBundleImage(sectionId, options);
        updateBundlePrice(sectionId, options);
      });

      // Listen for panel radio changes (these are static, no re-render)
      var panelSelector = document.getElementById('bundle-panel-selector-' + sectionId);
      if (panelSelector) {
        panelSelector.addEventListener('change', function () {
          updateBundleImage(sectionId);
          updateBundlePrice(sectionId);
        });
      }

      // Run on load to filter bundle images to correct variant
      updateBundleImage(sectionId);
      // Don't swap images on load — let Shopify show the featured image naturally
      updateBundlePrice(sectionId);
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[id^="bundle-add-to-cart-"]').forEach(function (btn) {
        var sectionId = btn.id.replace('bundle-add-to-cart-', '');
        initBundleImageSwap(sectionId);
        initBundleBuyButtons(sectionId);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["domes-comparison-chart"] && !Shopify.designMode) return;
  try {
    
  function equalizePriceHeights() {
    const priceEls = document.querySelectorAll('.lh-ultimate-product-price');
    if (priceEls.length === 0) return;

    let maxHeight = 0;
    priceEls.forEach(el => {
      el.style.minHeight = 'auto';
      if (el.offsetHeight > maxHeight) {
        maxHeight = el.offsetHeight;
      }
    });

    priceEls.forEach(el => {
      el.style.minHeight = maxHeight + 'px';
    });
  }

  function equalizeSpecRows() {
    const columns = document.querySelectorAll('.lh-ultimate-column');
    if (columns.length === 0) return;

    // Get all spec rows from the first column to know how many rows there are
    const firstColumn = columns[0];
    const rowCount = firstColumn.querySelectorAll('.lh-ultimate-spec-row').length;

    // For each row index, find the tallest row and set all rows at that index to that height
    for (let i = 0; i < rowCount; i++) {
      let maxHeight = 0;
      const rowsAtIndex = [];

      // Collect all rows at this index and find max height
      columns.forEach(column => {
        const row = column.querySelectorAll('.lh-ultimate-spec-row')[i];
        if (row) {
          row.style.height = 'auto'; // Reset height first
          rowsAtIndex.push(row);
          const rowHeight = row.offsetHeight;
          if (rowHeight > maxHeight) {
            maxHeight = rowHeight;
          }
        }
      });

      // Set all rows at this index to the max height
      rowsAtIndex.forEach(row => {
        row.style.height = maxHeight + 'px';
      });
    }
  }

  function equalizeHeaderHeights() {
    const headers = document.querySelectorAll('.lh-ultimate-column-header');
    if (headers.length === 0) return;

    let maxHeight = 0;
    headers.forEach(header => {
      header.style.minHeight = 'auto';
      if (header.offsetHeight > maxHeight) {
        maxHeight = header.offsetHeight;
      }
    });

    headers.forEach(header => {
      header.style.minHeight = maxHeight + 'px';
    });
  }

  function equalizeAll() {
    equalizePriceHeights();
    equalizeHeaderHeights();
    equalizeSpecRows();
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', equalizeAll);
  } else {
    equalizeAll();
  }

  // Run on resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equalizeAll, 250);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-categories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.faq-categories');

    sections.forEach(sectionWrapper => {
      initFAQCategories(sectionWrapper);
    });
  });

  function initFAQCategories(sectionWrapper) {
    if (!sectionWrapper) return;

    // Setup category navigation
    function setupCategoryNavigation() {
      const desktopButtons = sectionWrapper.querySelectorAll('.faq-categories__nav-button');
      const mobileButtons = sectionWrapper.querySelectorAll('.faq-categories__mobile-tab');

      // Desktop navigation
      desktopButtons.forEach(button => {
        button.addEventListener('click', () => {
          const categoryKey = button.dataset.categoryKey;
          switchCategory(categoryKey);
        });
      });

      // Mobile navigation
      mobileButtons.forEach(button => {
        button.addEventListener('click', () => {
          const categoryKey = button.dataset.categoryKey;
          switchCategory(categoryKey);
        });
      });
    }

    // Switch category
    function switchCategory(categoryKey) {
      // Update desktop navigation buttons
      sectionWrapper.querySelectorAll('.faq-categories__nav-button').forEach(button => {
        const isActive = button.dataset.categoryKey === categoryKey;
        button.classList.toggle('active', isActive);
        button.setAttribute('aria-pressed', isActive);
      });

      // Update mobile navigation buttons
      sectionWrapper.querySelectorAll('.faq-categories__mobile-tab').forEach(button => {
        const isActive = button.dataset.categoryKey === categoryKey;
        button.classList.toggle('active', isActive);
        button.setAttribute('aria-pressed', isActive);
      });

      // Update content sections
      sectionWrapper.querySelectorAll('.faq-categories__category').forEach(category => {
        const isActive = category.dataset.categoryKey === categoryKey;
        category.classList.toggle('active', isActive);
      });

      // Close all open accordions in the newly shown category
      const activeCategory = sectionWrapper.querySelector(`.faq-categories__category[data-category-key="${categoryKey}"]`);
      if (activeCategory) {
        const openItems = activeCategory.querySelectorAll('.faq-categories__item.active');
        openItems.forEach(item => {
          item.classList.remove('active');
          const button = item.querySelector('.faq-categories__question');
          if (button) {
            button.setAttribute('aria-expanded', 'false');
          }
        });
      }

      // Update URL hash without scrolling
      if (history.replaceState) {
        history.replaceState(null, null, `#${categoryKey}`);
      }
    }

    // Setup accordion functionality
    function setupAccordions() {
      const accordions = sectionWrapper.querySelectorAll('.faq-categories__item');

      accordions.forEach(accordion => {
        const toggle = accordion.querySelector('.faq-categories__question');

        if (toggle) {
          toggle.addEventListener('click', () => {
            const category = accordion.closest('.faq-categories__category');
            const isActive = accordion.classList.contains('active');

            // Use requestAnimationFrame to ensure simultaneous transitions
            requestAnimationFrame(() => {
              // Close all accordions in this category
              category.querySelectorAll('.faq-categories__item').forEach(item => {
                item.classList.remove('active');
                const itemButton = item.querySelector('.faq-categories__question');
                if (itemButton) {
                  itemButton.setAttribute('aria-expanded', 'false');
                }
              });

              // Open clicked accordion if it wasn't active
              if (!isActive) {
                accordion.classList.add('active');
                toggle.setAttribute('aria-expanded', 'true');
              }
            });
          });
        }
      });
    }

    // Handle URL hash on page load
    function handleHashOnLoad() {
      const hash = window.location.hash.substring(1);
      if (hash) {
        const categoryElement = sectionWrapper.querySelector(`[data-category-key="${hash}"]`);
        if (categoryElement) {
          switchCategory(hash);
        }
      }
    }

    // Initialize everything
    setupCategoryNavigation();
    setupAccordions();
    handleHashOnLoad();
  }

  // FAQ contact form AJAX submission
  (function() {
    function initFaqContactForm() {
      var form = document.getElementById('FaqContactForm');
      if (!form || form.dataset.ajaxInit) return;
      form.dataset.ajaxInit = '1';

      form.addEventListener('submit', function(e) {
        e.preventDefault();

        var successEl = document.getElementById('faq-contact-success');
        var errorEl = document.getElementById('faq-contact-error');
        var submitBtn = form.querySelector('[type="submit"]');

        successEl.style.display = 'none';
        errorEl.style.display = 'none';
        submitBtn.disabled = true;

        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'application/json' }
        })
        .then(function(response) {
          if (response.ok) {
            successEl.style.display = '';
            form.reset();
          } else {
            errorEl.style.display = '';
          }
        })
        .catch(function() {
          errorEl.style.display = '';
        })
        .finally(function() {
          submitBtn.disabled = false;
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFaqContactForm);
    } else {
      initFaqContactForm();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["far-infrared-therapy"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const section = document.getElementById('FarInfraredTherapy-{{ section.id }}');
    if (!section) return;

    const accordions = section.querySelectorAll('.far-infrared__accordion');

    accordions.forEach(accordion => {
      const toggle = accordion.querySelector('.far-infrared__accordion-toggle');
      const content = accordion.querySelector('.far-infrared__accordion-content');

      if (toggle && content) {
        toggle.addEventListener('click', function() {
          const isActive = accordion.classList.contains('active');

          // Close all accordions
          accordions.forEach(acc => {
            acc.classList.remove('active');
          });

          // Open clicked accordion if it wasn't active
          if (!isActive) {
            accordion.classList.add('active');
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      // headerBounds is no longer used for scroll thresholds — we use offsetHeight directly
      // so that stale getBoundingClientRect values (which can be 0 on iOS before layout) never
      // cause the header to hide immediately on product pages.
      this.headerBounds = { top: 0, bottom: this.header.offsetHeight };
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      // Use live offsetHeight so iOS layout-timing issues never produce a threshold of 0.
      const headerHeight = this.header.offsetHeight;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > headerHeight) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > headerHeight) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= 0) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.preventHide) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Open dropdown menus on hover for desktop
  if (window.innerWidth >= 990) {
    const headerMenus = document.querySelectorAll('header-menu');

    headerMenus.forEach(menu => {
      const details = menu.querySelector('details');

      if (details) {
        menu.addEventListener('mouseenter', () => {
          details.setAttribute('open', '');
        });

        menu.addEventListener('mouseleave', () => {
          details.removeAttribute('open');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.banner__media video').forEach(function(video) {
    var alt = video.closest('[data-video-alt]')?.dataset.videoAlt || '';
    var img = video.querySelector('img');
    if (img) img.setAttribute('alt', alt);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["learn-blog"]) return;
  try {
    
  (function() {
    const sectionHeader = document.querySelector('.section-header');
    const searchBar = document.querySelector('.learn-blog__search');
    const sentinel = document.querySelector('.learn-blog__search-sentinel');

    function updateSearchTop() {
      const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '0');
      const isHidden = sectionHeader && sectionHeader.classList.contains('shopify-section-header-hidden');
      document.documentElement.style.setProperty('--learn-blog-search-top', isHidden ? '0px' : headerHeight + 'px');
    }

    if (sectionHeader) {
      new MutationObserver(updateSearchTop).observe(sectionHeader, { attributes: true, attributeFilter: ['class'] });
    }
    window.addEventListener('scroll', updateSearchTop, { passive: true });
    updateSearchTop();

    // Add is-sticky class only when search bar has scrolled past its natural position
    if (sentinel && searchBar) {
      function updateStickyClass() {
        const stickyTop = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--learn-blog-search-top') || '0');
        const sentinelPageTop = sentinel.getBoundingClientRect().top + window.scrollY;
        searchBar.classList.toggle('is-sticky', window.scrollY > sentinelPageTop - stickyTop);
      }
      window.addEventListener('scroll', updateStickyClass, { passive: true });
      updateStickyClass();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (function() {
    const sectionHeader = document.querySelector('.section-header');
    const searchBar = document.querySelector('.template-search__search-sticky');

    function updateSearchTop() {
      const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '0');
      const isHidden = sectionHeader && sectionHeader.classList.contains('shopify-section-header-hidden');
      document.documentElement.style.setProperty('--learn-blog-search-top', isHidden ? '0px' : headerHeight + 'px');
    }

    if (sectionHeader) {
      new MutationObserver(updateSearchTop).observe(sectionHeader, { attributes: true, attributeFilter: ['class'] });
    }
    window.addEventListener('scroll', updateSearchTop, { passive: true });
    updateSearchTop();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.product-comparison');

    sections.forEach(section => {
      initProductComparison(section);
    });
  });

  function initProductComparison(section) {
    if (!section) return;

    let currentVariant = 'ultimate';
    const carousels = {};
    const autoAdvanceTimers = {};

    // Setup tabs
    function setupTabs() {
      const tabs = section.querySelectorAll('.product-comparison__tab');
      const tabsContainer = section.querySelector('.product-comparison__tabs');

      // Position underline on initial load
      updateUnderlinePosition();

      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const variant = tab.dataset.variant;
          switchVariant(variant);
        });
      });

      // Update underline position on window resize
      window.addEventListener('resize', updateUnderlinePosition);
    }

    function updateUnderlinePosition() {
      const activeTab = section.querySelector('.product-comparison__tab.active');
      const tabsContainer = section.querySelector('.product-comparison__tabs');

      if (!activeTab || !tabsContainer) return;

      const tabRect = activeTab.getBoundingClientRect();
      const containerRect = tabsContainer.getBoundingClientRect();

      // Calculate position relative to container with extended width
      // Adjust extension based on screen size
      const windowWidth = window.innerWidth;
      let extension;

      if (windowWidth <= 989) {
        extension = 15; // Mobile or Tablet
      } else {
        extension = 20; // Desktop
      }

      const left = tabRect.left - containerRect.left - extension;
      const width = tabRect.width + (extension * 2);

      // Apply styles to the ::after pseudo-element via CSS custom properties
      tabsContainer.style.setProperty('--underline-left', `${left}px`);
      tabsContainer.style.setProperty('--underline-width', `${width}px`);
    }

    function switchVariant(variant) {
      if (currentVariant === variant) return;

      // Stop current carousel auto-advance
      if (autoAdvanceTimers[currentVariant]) {
        clearInterval(autoAdvanceTimers[currentVariant]);
      }

      // Update tabs
      section.querySelectorAll('.product-comparison__tab').forEach(tab => {
        tab.classList.toggle('active', tab.dataset.variant === variant);
      });

      // Update underline position
      updateUnderlinePosition();

      // Fade out current variant
      const currentVariantEl = section.querySelector(`.product-comparison__variant[data-variant="${currentVariant}"]`);
      const newVariantEl = section.querySelector(`.product-comparison__variant[data-variant="${variant}"]`);

      if (currentVariantEl) {
        currentVariantEl.classList.remove('active');
      }

      // Wait for fade out, then switch and fade in
      setTimeout(() => {
        section.querySelectorAll('.product-comparison__variant').forEach(variantEl => {
          if (variantEl.dataset.variant === variant) {
            variantEl.style.display = 'block';
            // Trigger reflow to ensure transition works
            variantEl.offsetHeight;
            variantEl.classList.add('active');
          } else {
            variantEl.style.display = 'none';
            variantEl.classList.remove('active');
          }
        });

        currentVariant = variant;

        // Start new carousel auto-advance
        startAutoAdvance(variant);
      }, 400); // Match CSS transition duration
    }

    function setupCarousels() {
      const variants = section.querySelectorAll('.product-comparison__variant');

      variants.forEach(variant => {
        const variantName = variant.dataset.variant;
        const slides = variant.querySelectorAll('.product-comparison__carousel-slide');
        const dots = variant.querySelectorAll('.product-comparison__carousel-dot');
        const prevBtn = variant.querySelector('.product-comparison__carousel-arrow--prev');
        const nextBtn = variant.querySelector('.product-comparison__carousel-arrow--next');
        const carousel = variant.querySelector('.product-comparison__carousel');

        if (slides.length === 0) return;

        carousels[variantName] = {
          currentIndex: 0,
          slides: slides,
          dots: dots,
          totalSlides: slides.length
        };

        // Arrow navigation
        if (prevBtn) {
          prevBtn.addEventListener('click', () => {
            navigateCarousel(variantName, -1);
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', () => {
            navigateCarousel(variantName, 1);
          });
        }

        // Dot navigation
        dots.forEach(dot => {
          dot.addEventListener('click', () => {
            const index = parseInt(dot.dataset.index);
            goToSlide(variantName, index);
          });
        });

        // Touch/Swipe functionality
        if (carousel) {
          let touchStartX = 0;
          let touchEndX = 0;
          let touchStartY = 0;
          let touchEndY = 0;

          carousel.addEventListener('touchstart', (e) => {
            touchStartX = e.changedTouches[0].screenX;
            touchStartY = e.changedTouches[0].screenY;
          }, { passive: true });

          carousel.addEventListener('touchend', (e) => {
            touchEndX = e.changedTouches[0].screenX;
            touchEndY = e.changedTouches[0].screenY;
            handleSwipe(variantName);
          }, { passive: true });

          function handleSwipe(variant) {
            const swipeThreshold = 50;
            const horizontalDistance = Math.abs(touchEndX - touchStartX);
            const verticalDistance = Math.abs(touchEndY - touchStartY);

            // Only handle swipe if horizontal movement is greater than vertical (to avoid interfering with scrolling)
            if (horizontalDistance > verticalDistance && horizontalDistance > swipeThreshold) {
              if (touchEndX < touchStartX) {
                // Swipe left - next slide
                navigateCarousel(variant, 1);
              } else if (touchEndX > touchStartX) {
                // Swipe right - previous slide
                navigateCarousel(variant, -1);
              }
            }
          }

          // Pause on hover
          carousel.addEventListener('mouseenter', () => {
            if (autoAdvanceTimers[variantName]) {
              clearInterval(autoAdvanceTimers[variantName]);
            }
          });

          carousel.addEventListener('mouseleave', () => {
            if (variantName === currentVariant) {
              startAutoAdvance(variantName);
            }
          });
        }

        // Start auto-advance for initial variant
        if (variantName === 'ultimate') {
          startAutoAdvance(variantName);
        }
      });
    }

    function navigateCarousel(variant, direction) {
      const carousel = carousels[variant];
      if (!carousel) return;

      let newIndex = carousel.currentIndex + direction;

      if (newIndex < 0) {
        newIndex = carousel.totalSlides - 1;
      } else if (newIndex >= carousel.totalSlides) {
        newIndex = 0;
      }

      goToSlide(variant, newIndex);
    }

    function goToSlide(variant, index) {
      const carousel = carousels[variant];
      if (!carousel) return;

      // Reset auto-advance timer
      if (autoAdvanceTimers[variant]) {
        clearInterval(autoAdvanceTimers[variant]);
      }
      if (variant === currentVariant) {
        startAutoAdvance(variant);
      }

      // Update slides
      carousel.slides.forEach((slide, i) => {
        slide.classList.toggle('active', i === index);
      });

      // Update dots
      carousel.dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });

      carousel.currentIndex = index;
    }

    function startAutoAdvance(variant) {
      if (autoAdvanceTimers[variant]) {
        clearInterval(autoAdvanceTimers[variant]);
      }

      autoAdvanceTimers[variant] = setInterval(() => {
        navigateCarousel(variant, 1);
      }, 4000);
    }

    function setupAccordions() {
      const accordions = section.querySelectorAll('.product-comparison__accordion');

      accordions.forEach(accordion => {
        const toggle = accordion.querySelector('.product-comparison__accordion-toggle');

        if (toggle) {
          toggle.addEventListener('click', () => {
            const variant = accordion.closest('.product-comparison__variant');
            const isActive = accordion.classList.contains('active');

            // Use requestAnimationFrame to ensure simultaneous transitions
            requestAnimationFrame(() => {
              // Close all accordions in this variant
              variant.querySelectorAll('.product-comparison__accordion').forEach(acc => {
                acc.classList.remove('active');
              });

              // Open clicked accordion if it wasn't active
              if (!isActive) {
                accordion.classList.add('active');
              }
            });
          });
        }
      });
    }

    // Initialize everything
    setupTabs();
    setupCarousels();
    setupAccordions();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  function setupAccordions(section) {
    const accordions = section.querySelectorAll('.product-faq__accordion');

    accordions.forEach(accordion => {
      const toggle = accordion.querySelector('.product-faq__accordion-toggle');

      if (toggle) {
        toggle.addEventListener('click', () => {
          const isActive = accordion.classList.contains('active');

          // Use requestAnimationFrame to ensure smooth transitions
          requestAnimationFrame(() => {
            // Close all accordions in this section
            section.querySelectorAll('.product-faq__accordion').forEach(acc => {
              acc.classList.remove('active');
            });

            // Open clicked accordion if it wasn't active
            if (!isActive) {
              accordion.classList.add('active');
            }
          });
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.product-faq');

    sections.forEach(section => {
      setupAccordions(section);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-safety"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('product-safety__visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll('.product-safety__animate-left, .product-safety__animate-right');
    animatedElements.forEach(function(element) {
      observer.observe(element);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const reviewSections = document.querySelectorAll('.reviews');

    reviewSections.forEach(section => {
      initReviews(section);
    });
  });

  function initReviews(section) {
    if (!section) return;

    const track = section.querySelector('.reviews__track');
    const cards = section.querySelectorAll('.reviews__card');
    const prevBtn = section.querySelector('.reviews__arrow--prev');
    const nextBtn = section.querySelector('.reviews__arrow--next');
    const carousel = section.querySelector('.reviews__carousel');

    if (!track || cards.length === 0) return;

    let currentIndex = Math.min(2, cards.length - 1); // Start at 3rd card centered
    let cardsPerView = getCardsPerView();

    // Initialize - add center class to current card and active class for fallback
    cards.forEach((card, index) => {
      if (index === currentIndex) {
        card.classList.add('center');
        card.classList.add('active');
      }
    });

    requestAnimationFrame(() => {
      updateCarousel();
      updateArrows();
    });

    // Navigation
    if (prevBtn) {
      prevBtn.addEventListener('click', () => navigateCarousel(-1));
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => navigateCarousel(1));
    }

    // Read more toggle
    const readMoreBtns = section.querySelectorAll('.reviews__read-more');
    readMoreBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const container = btn.closest('.reviews__text-container');
        const truncated = container.querySelector('.reviews__text--truncated');
        const full = container.querySelector('.reviews__text--full');

        if (truncated.style.display !== 'none') {
          truncated.style.display = 'none';
          full.style.display = '';
          btn.textContent = 'Show less';
        } else {
          truncated.style.display = '';
          full.style.display = 'none';
          btn.textContent = 'Continue reading';
        }
      });
    });

    // Card click support (all devices)
    cards.forEach((card, index) => {
      card.addEventListener('click', () => {
        currentIndex = index;
        updateCarousel();
      });

      card.style.cursor = 'pointer';
    });

    // Touch/Swipe support with snap-to-center
    let touchStartX = 0;
    let touchStartY = 0;
    let touchCurrentX = 0;
    let isDragging = false;
    let dragOffset = 0;
    let startTranslateX = 0;
    let isHorizontalSwipe = null;

    if (carousel) {
      carousel.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].clientX;
        touchStartY = e.changedTouches[0].clientY;
        touchCurrentX = touchStartX;
        isDragging = true;
        isHorizontalSwipe = null;
        dragOffset = 0;

        // Get current translateX
        const transform = window.getComputedStyle(track).transform;
        if (transform && transform !== 'none') {
          const matrix = new DOMMatrix(transform);
          startTranslateX = matrix.m41;
        } else {
          startTranslateX = 0;
        }

        // Disable transition during drag
        track.style.transition = 'none';
      }, { passive: true });

      carousel.addEventListener('touchmove', (e) => {
        if (!isDragging) return;

        const currentX = e.changedTouches[0].clientX;
        const currentY = e.changedTouches[0].clientY;

        // Determine swipe direction on first move
        if (isHorizontalSwipe === null) {
          const dx = Math.abs(currentX - touchStartX);
          const dy = Math.abs(currentY - touchStartY);
          if (dx > 5 || dy > 5) {
            isHorizontalSwipe = dx > dy;
          }
        }

        if (!isHorizontalSwipe) return;

        touchCurrentX = currentX;
        dragOffset = touchCurrentX - touchStartX;

        // Move the track with the finger
        track.style.transform = `translateX(${startTranslateX + dragOffset}px)`;
      }, { passive: true });

      carousel.addEventListener('touchend', () => {
        if (!isDragging) return;
        isDragging = false;

        // Re-enable transition
        track.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';

        if (!isHorizontalSwipe) {
          updateCarousel();
          return;
        }

        const swipeThreshold = 40;

        if (Math.abs(dragOffset) > swipeThreshold) {
          if (dragOffset < 0) {
            navigateCarousel(1);
          } else {
            navigateCarousel(-1);
          }
        } else {
          // Snap back to current card
          updateCarousel();
        }
      }, { passive: true });
    }

    // Window resize
    window.addEventListener('resize', () => {
      const newCardsPerView = getCardsPerView();
      if (newCardsPerView !== cardsPerView) {
        cardsPerView = newCardsPerView;
        updateCarousel();
      }
    });

    function navigateCarousel(direction) {
      currentIndex += direction;

      // Boundary checks
      if (currentIndex < 0) {
        currentIndex = 0;
      } else if (currentIndex >= cards.length) {
        currentIndex = cards.length - 1;
      }

      updateCarousel();
    }

    function updateCarousel() {
      const isMobile = window.innerWidth <= 749;
      const gap = isMobile ? 15 : 20; // 1.5rem on mobile, 2rem on desktop
      const containerWidth = track.parentElement.offsetWidth;

      // First update which card should be centered (to get correct sizing)
      updateCenterCard();

      // Get the actual center card (current card) after classes are applied
      const centerCard = cards[currentIndex];

      // Force a reflow to ensure the center card has the correct size
      centerCard.offsetWidth;

      const centerCardWidth = centerCard.offsetWidth;

      // Calculate offset to center the current card
      let offset;

      // Calculate total width of cards before current index
      let totalWidthBefore = 0;
      for (let i = 0; i < currentIndex; i++) {
        totalWidthBefore += cards[i].offsetWidth + gap;
      }

      // Center the current card in the viewport
      offset = (containerWidth / 2) - (centerCardWidth / 2) - totalWidthBefore;

      track.style.transform = `translateX(${offset}px)`;
      updateArrows();
    }

    function updateCenterCard() {
      const isMobile = window.innerWidth <= 749;
      const centerCard = cards[currentIndex];

      cards.forEach((card, index) => {
        if (index === currentIndex) {
          card.classList.add('center');
          card.classList.add('active');
          card.style.maxHeight = '';
          card.style.overflow = '';
        } else {
          card.classList.remove('center');
          card.classList.remove('active');
          // On mobile, cap side cards to center card height so they don't add whitespace
          if (isMobile) {
            card.style.maxHeight = centerCard.offsetHeight + 'px';
            card.style.overflow = 'hidden';
          }
          // Reset expanded text after transition so it doesn't visibly snap
          setTimeout(() => {
            const truncated = card.querySelector('.reviews__text--truncated');
            const full = card.querySelector('.reviews__text--full');
            const btn = card.querySelector('.reviews__read-more');
            if (truncated && full && btn) {
              truncated.style.display = '';
              full.style.display = 'none';
              btn.textContent = 'Continue reading';
            }
          }, 500);
        }
      });
    }

    function updateArrows() {
      if (prevBtn) {
        prevBtn.disabled = currentIndex === 0;
      }
      if (nextBtn) {
        nextBtn.disabled = currentIndex >= cards.length - 1;
      }
    }

    function getCardsPerView() {
      const width = window.innerWidth;
      if (width <= 749) return 1;
      if (width <= 989) return 3;
      return 5;
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-shipping"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var toggle = document.getElementById('shipping-map-toggle');
    var panel = document.getElementById('shipping-map-panel');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function() {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        toggle.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
      } else {
        toggle.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-subnav"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const nav = document.getElementById('support-subnav');
    if (!nav) return;

    const links = nav.querySelectorAll('.support-subnav__link');
    const anchors = Array.from(links).map(link => {
      const id = link.getAttribute('href').replace('#', '');
      return { link, target: document.getElementById(id) };
    }).filter(item => item.target);

    function getHeaderHeight() {
      return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '0');
    }

    const navEl = nav.querySelector('.support-subnav__nav');
    let isClicking = false;
    let clickTimeout = null;
    let activeLink = null;

    function scrollNavToLink(link) {
      if (!navEl) return;
      const linkLeft = link.offsetLeft;
      const linkWidth = link.offsetWidth;
      const navWidth = navEl.offsetWidth;
      navEl.scrollTo({ left: linkLeft - (navWidth / 2) + (linkWidth / 2), behavior: 'smooth' });
    }

    function setActive() {
      if (isClicking) return;
      const trigger = getHeaderHeight() + nav.offsetHeight + window.innerHeight * 0.35;
      let current = anchors[0];
      for (const item of anchors) {
        if (item.target.getBoundingClientRect().top <= trigger) {
          current = item;
        }
      }
      if (current && current.link !== activeLink) {
        links.forEach(link => link.classList.remove('active'));
        current.link.classList.add('active');
        activeLink = current.link;
        scrollNavToLink(current.link);
      }
    }

    links.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const id = this.getAttribute('href').replace('#', '');
        const target = document.getElementById(id);
        if (!target) return;

        isClicking = true;
        clearTimeout(clickTimeout);

        links.forEach(l => l.classList.remove('active'));
        this.classList.add('active');
        activeLink = this;
        scrollNavToLink(this);

        // After scrolling, the header will be hidden (preventHeaderReveal fires below),
        // so the subnav will stick at top: 0. Use nav height only as the final offset.
        const finalStickyBottom = nav.offsetHeight;
        const top = target.getBoundingClientRect().top + window.scrollY - finalStickyBottom;
        window.scrollTo({ top, behavior: 'smooth' });

        const stickyHeader = document.querySelector('sticky-header');
        if (stickyHeader) stickyHeader.dispatchEvent(new CustomEvent('preventHeaderReveal'));

        clickTimeout = setTimeout(() => { isClicking = false; }, 800);
      });
    });

    window.addEventListener('scroll', setActive, { passive: true });
    setActive();

    // Track header bottom to set sticky top — same pattern as therapy-benefits
    const headerWrapper = document.querySelector('.header-wrapper');
    const sectionHeader = document.querySelector('.section-header');
    const subnavEl = document.getElementById('support-subnav');
    let rafId = null;

    function updateSubnavTop() {
      const headerBottom = headerWrapper ? Math.max(0, headerWrapper.getBoundingClientRect().bottom) : 0;
      document.documentElement.style.setProperty('--subnav-sticky-top', headerBottom + 'px');
      if (subnavEl) {
        const subnavTop = subnavEl.getBoundingClientRect().top;
        subnavEl.classList.toggle('is-sticky', Math.abs(subnavTop - headerBottom) < 2);
      }
    }

    function trackDuringTransition() {
      updateSubnavTop();
      rafId = requestAnimationFrame(trackDuringTransition);
    }

    if (sectionHeader) {
      sectionHeader.addEventListener('transitionstart', function() {
        if (!rafId) rafId = requestAnimationFrame(trackDuringTransition);
      });
      sectionHeader.addEventListener('transitionend', function() {
        if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
        updateSubnavTop();
      });
      sectionHeader.addEventListener('transitioncancel', function() {
        if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
        updateSubnavTop();
      });
    }

    window.addEventListener('scroll', updateSubnavTop, { passive: true });
    updateSubnavTop();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["therapy-benefits"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.therapy-benefits-wrapper');

    sections.forEach(section => {
      initTherapyBenefits(section);
    });
  });

  function initTherapyBenefits(section) {
    if (!section) return;

    // Get the first active tab's therapy type
    const firstTab = section.querySelector('.therapy-benefits__tab');
    let currentTherapy = firstTab ? firstTab.dataset.therapy : 'therapy-1';

    // Store observer reference for cleanup
    let scrollObserver = null;

    // Setup scroll animations for content blocks
    function setupScrollAnimations(therapySelector = null) {
      // Clean up existing observer
      if (scrollObserver) {
        scrollObserver.disconnect();
      }

      // Get blocks from specific therapy or all visible blocks
      let therapyEl;
      if (therapySelector) {
        therapyEl = section.querySelector(`.therapy-benefits__therapy[data-therapy="${therapySelector}"]`);
      } else {
        therapyEl = section.querySelector('.therapy-benefits__therapy.active');
      }

      const blocks = therapyEl ? therapyEl.querySelectorAll('.therapy-block') : [];
      const iconItems = therapyEl ? therapyEl.querySelectorAll('.therapy-icon-grid__item') : [];

      const observerOptions = {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: 0.1
      };

      scrollObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !entry.target.classList.contains('animate-in')) {
            const isIconItem = entry.target.classList.contains('therapy-icon-grid__item');
            if (isIconItem) {
              const grid = entry.target.closest('.therapy-icon-grid__grid');
              const allItems = grid ? Array.from(grid.querySelectorAll('.therapy-icon-grid__item')) : [];
              const index = allItems.indexOf(entry.target);
              setTimeout(() => {
                entry.target.classList.add('animate-in');
              }, index * 60);
            } else {
              const therapyContainer = entry.target.closest('.therapy-benefits__therapy');
              const blocksInContainer = Array.from(therapyContainer.querySelectorAll('.therapy-block'));
              const index = blocksInContainer.indexOf(entry.target);
              setTimeout(() => {
                entry.target.classList.add('animate-in');
              }, index * 50);
            }
          }
        });
      }, observerOptions);

      blocks.forEach(block => {
        scrollObserver.observe(block);
      });

      iconItems.forEach(item => {
        scrollObserver.observe(item);
      });
    }

    function setupTabs() {
      const tabs = section.querySelectorAll('.therapy-benefits__tab');
      const tabsContainer = section.querySelector('.therapy-benefits__tabs');

      updateUnderlinePosition();

      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const therapy = tab.dataset.therapy;
          switchTherapy(therapy);
        });
      });

      window.addEventListener('resize', updateUnderlinePosition);
    }

    function updateUnderlinePosition() {
      const activeTab = section.querySelector('.therapy-benefits__tab.active');
      const tabsContainer = section.querySelector('.therapy-benefits__tabs');

      if (!activeTab || !tabsContainer) return;

      if (window.innerWidth <= 749) return;

      const tabRect = activeTab.getBoundingClientRect();
      const containerRect = tabsContainer.getBoundingClientRect();

      const windowWidth = window.innerWidth;
      let extension;

      if (windowWidth <= 989) {
        extension = 15;
      } else {
        extension = 20;
      }

      const left = tabRect.left - containerRect.left - extension;
      const width = tabRect.width + (extension * 2);

      tabsContainer.style.setProperty('--underline-left', `${left}px`);
      tabsContainer.style.setProperty('--underline-width', `${width}px`);
    }

    function switchTherapy(therapy) {
      if (currentTherapy === therapy) return;

      section.querySelectorAll('.therapy-benefits__tab').forEach(tab => {
        tab.classList.toggle('active', tab.dataset.therapy === therapy);
      });

      updateUnderlinePosition();

      // Scroll to section top without triggering Shopify header reveal
      const stickyTop = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--tabs-sticky-top') || '0');
      const wrapperTop = section.getBoundingClientRect().top + window.scrollY;
      const scrollTarget = wrapperTop - stickyTop;
      if (window.scrollY > scrollTarget) {
        window.scrollTo({ top: scrollTarget, behavior: 'smooth' });
        const stickyHeader = document.querySelector('sticky-header');
        if (stickyHeader) stickyHeader.dispatchEvent(new CustomEvent('preventHeaderReveal'));
      }

      // Switch content immediately without transitions
      section.querySelectorAll('.therapy-benefits__therapy').forEach(therapyEl => {
        if (therapyEl.dataset.therapy === therapy) {
          // Reset blocks and icon grid items before showing
          therapyEl.querySelectorAll('.therapy-block, .therapy-icon-grid__item').forEach(el => {
            el.classList.remove('animate-in');
          });

          therapyEl.style.display = 'block';
          therapyEl.classList.add('active');

          // Re-initialize scroll animations for the new therapy
          setTimeout(() => {
            setupScrollAnimations(therapy);
          }, 20);
        } else {
          therapyEl.style.display = 'none';
          therapyEl.classList.remove('active');
        }
      });

      currentTherapy = therapy;

      // Emit event for other sections to listen
      const event = new CustomEvent('therapyTabChanged', {
        detail: { therapy: therapy }
      });
      document.dispatchEvent(event);
    }

    setupTabs();

    // Delay initial animation setup to ensure DOM is ready
    setTimeout(() => {
      setupScrollAnimations();
    }, 50);
  }

  // Sticky tabs top offset — tracks header's actual bottom position frame-by-frame during transitions
  (function() {
    const headerWrapper = document.querySelector('.header-wrapper');
    const sectionHeader = document.querySelector('.section-header');
    const subnav = document.getElementById('support-subnav');
    const tabsSticky = document.querySelector('.therapy-benefits__tabs-sticky');
    let rafId = null;

    function updateTabsTop() {
      const headerBottom = headerWrapper ? Math.max(0, headerWrapper.getBoundingClientRect().bottom) : 0;
      const subnavH = subnav ? subnav.offsetHeight : 0;
      document.documentElement.style.setProperty('--tabs-sticky-top', (headerBottom + subnavH) + 'px');

      if (tabsSticky) {
        const tabsTop = tabsSticky.getBoundingClientRect().top;
        const stickyTop = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--tabs-sticky-top') || '0');
        tabsSticky.classList.toggle('is-sticky', Math.abs(tabsTop - stickyTop) < 2);
      }
    }

    function trackDuringTransition() {
      updateTabsTop();
      rafId = requestAnimationFrame(trackDuringTransition);
    }

    function startTracking() {
      if (!rafId) rafId = requestAnimationFrame(trackDuringTransition);
    }

    function stopTracking() {
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      updateTabsTop();
    }

    if (sectionHeader) {
      sectionHeader.addEventListener('transitionstart', startTracking);
      sectionHeader.addEventListener('transitionend', stopTracking);
      sectionHeader.addEventListener('transitioncancel', stopTracking);
    }

    window.addEventListener('scroll', updateTabsTop, { passive: true });
    updateTabsTop();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["therapy-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const carousels = {};
    let scrollObserver = null;

    // Initialize all carousels
    document.querySelectorAll('.therapy-products__carousel').forEach(carousel => {
      const therapy = carousel.dataset.therapy;
      carousels[therapy] = {
        element: carousel,
        track: carousel.querySelector('.therapy-products__track'),
        currentIndex: 0,
        itemsPerView: getItemsPerView()
      };
    });

    function applyNoArrowsMode() {
      document.querySelectorAll('.therapy-products__carousel-wrapper').forEach(wrapper => {
        const count = parseInt(wrapper.dataset.count, 10);
        if (window.innerWidth >= 750 && count <= 4) {
          wrapper.classList.add('no-arrows');
        } else {
          wrapper.classList.remove('no-arrows');
        }
      });
    }

    applyNoArrowsMode();

    // Setup scroll animations for carousel wrappers
    function setupScrollAnimations() {
      // Clean up existing observer
      if (scrollObserver) {
        scrollObserver.disconnect();
      }

      const carouselWrappers = document.querySelectorAll('.therapy-products__carousel-wrapper');

      const observerOptions = {
        root: null,
        rootMargin: '0px 0px 150px 0px',
        threshold: 0.1
      };

      scrollObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.target.classList.contains('active')) {
            const wrapper = entry.target;
            const cards = wrapper.querySelectorAll('.therapy-products__card');
            const itemsPerView = getItemsPerView();

            // Animate only the initially visible cards
            cards.forEach((card, index) => {
              if (index < itemsPerView) {
                // Animate initially visible cards
                setTimeout(() => {
                  card.classList.add('animate-in');
                }, index * 50);
              } else {
                // All other cards should just be visible without animation
                card.classList.add('animate-in');
              }
            });

            // Stop observing after animation
            scrollObserver.unobserve(wrapper);
          }
        });
      }, observerOptions);

      carouselWrappers.forEach(wrapper => {
        scrollObserver.observe(wrapper);
      });
    }

    // Set CSS variable for image height so arrows center on the image
    function updateImageHeight() {
      const img = document.querySelector('.therapy-products__image');
      if (img) {
        document.documentElement.style.setProperty('--product-image-height', img.offsetHeight + 'px');
      }
    }
    updateImageHeight();
    window.addEventListener('resize', updateImageHeight);

    // Initial positioning after images load
    setTimeout(() => {
      Object.keys(carousels).forEach(therapy => {
        updateCarouselPosition(therapy);
      });
      updateImageHeight();
    }, 100);

    // Setup arrow navigation
    document.querySelectorAll('.therapy-products__arrow').forEach(arrow => {
      arrow.addEventListener('click', function(e) {
        e.preventDefault();
        const therapy = this.dataset.therapy;
        const direction = this.classList.contains('therapy-products__arrow--prev') ? -1 : 1;

        if (carousels[therapy]) {
          scrollCarousel(therapy, direction);
        }
      });
    });

    // Listen for therapy tab changes from therapy-benefits section
    document.addEventListener('therapyTabChanged', function(e) {
      const therapy = e.detail.therapy;
      switchProductCarousel(therapy);
    });

    // Handle window resize
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        applyNoArrowsMode();
        Object.keys(carousels).forEach(therapy => {
          carousels[therapy].itemsPerView = getItemsPerView();
          carousels[therapy].currentIndex = 0;
          updateCarouselPosition(therapy);
        });
      }, 250);
    });

    // Touch/swipe support for mobile
    let touchStartX = 0;
    let touchEndX = 0;

    document.querySelectorAll('.therapy-products__carousel').forEach(carousel => {
      carousel.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      carousel.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        const therapy = this.dataset.therapy;
        handleSwipe(therapy);
      }, { passive: true });
    });

    function getItemsPerView() {
      if (window.innerWidth <= 749) return 1;
      if (window.innerWidth <= 989) return 3;
      return 4;
    }

    function scrollCarousel(therapy, direction) {
      const carousel = carousels[therapy];
      if (!carousel || !carousel.track) return;

      const totalItems = carousel.track.children.length;

      // Calculate max index based on screen size
      let maxIndex;
      if (window.innerWidth <= 749) {
        // Mobile: can scroll to show each individual card
        maxIndex = Math.max(0, totalItems - 1);
      } else {
        // Tablet/Desktop: ensure last card is fully visible
        // Allow at least 1 scroll position if we have 4+ items
        maxIndex = Math.max(0, totalItems - carousel.itemsPerView);
        if (totalItems >= 4 && maxIndex === 0) {
          maxIndex = 1;
        }
      }

      const newIndex = carousel.currentIndex + direction;

      // Only update if within bounds
      if (newIndex >= 0 && newIndex <= maxIndex) {
        carousel.currentIndex = newIndex;
        updateCarouselPosition(therapy);
      }
    }

    function updateCarouselPosition(therapy) {
      const carousel = carousels[therapy];
      if (!carousel.track.children[0]) return;

      const cardWidth = carousel.track.children[0].offsetWidth;
      const gap = 20; // 2rem gap
      const totalItems = carousel.track.children.length;

      // On mobile, center each card perfectly with peek effect on sides
      if (window.innerWidth <= 749) {
        const viewportWidth = carousel.element.offsetWidth;
        const centerOffset = (viewportWidth / 2) - (cardWidth / 2);
        const scrollDistance = cardWidth + gap;
        const offset = centerOffset - (carousel.currentIndex * scrollDistance);

        carousel.track.style.transform = `translateX(${offset}px)`;
      } else {
        // Desktop/Tablet: check if scrolling is needed
        if (totalItems < carousel.itemsPerView) {
          // Not enough items to scroll, keep at start position
          carousel.track.style.transform = `translateX(0px)`;
          return;
        }

        // Desktop/Tablet: ensure last items are fully visible
        const maxIndex = Math.max(0, totalItems - carousel.itemsPerView);

        // If at the start, no transform needed
        if (carousel.currentIndex === 0) {
          carousel.track.style.transform = `translateX(0px)`;
        }
        // If we're at or beyond the max scroll position, calculate offset to show last full set
        else if (carousel.currentIndex >= maxIndex && maxIndex > 0) {
          const containerWidth = carousel.element.offsetWidth;
          const totalWidth = (cardWidth * totalItems) + (gap * (totalItems - 1));
          const offset = -(totalWidth - containerWidth);
          carousel.track.style.transform = `translateX(${offset}px)`;
        }
        // Normal scrolling
        else {
          const offset = -(carousel.currentIndex * (cardWidth + gap));
          carousel.track.style.transform = `translateX(${offset}px)`;
        }
      }
    }

    function handleSwipe(therapy) {
      if (touchEndX < touchStartX - 50) {
        scrollCarousel(therapy, 1);
      }
      if (touchEndX > touchStartX + 50) {
        scrollCarousel(therapy, -1);
      }
    }

    function switchProductCarousel(therapy) {
      const allWrappers = document.querySelectorAll('.therapy-products__carousel-wrapper');

      allWrappers.forEach(wrapper => {
        if (wrapper.dataset.therapy === therapy) {
          // Show the wrapper first
          wrapper.style.display = 'block';
          wrapper.classList.add('active');

          // Reset carousel to first item
          if (carousels[therapy]) {
            carousels[therapy].currentIndex = 0;
            carousels[therapy].itemsPerView = getItemsPerView();
          }

          // Force reflow so the browser registers the display change
          wrapper.offsetHeight;

          // Update carousel position now that wrapper is visible
          if (carousels[therapy]) {
            updateCarouselPosition(therapy);
          }

          // Reset all cards to hidden, force reflow, then stagger animate in
          const cards = Array.from(wrapper.querySelectorAll('.therapy-products__card'));
          cards.forEach(card => card.classList.remove('animate-in'));
          void wrapper.offsetWidth; // force reflow so transition fires from opacity:0
          cards.forEach((card, index) => {
            setTimeout(() => card.classList.add('animate-in'), index * 60);
          });
        } else {
          wrapper.classList.remove('active');
          wrapper.style.display = 'none';
        }
      });
    }

    // Initialize scroll animations on load
    setTimeout(() => {
      setupScrollAnimations();
    }, 50);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["troubleshooting"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var sections = document.querySelectorAll('.troubleshooting');

    sections.forEach(function(sectionWrapper) {
      initTroubleshooting(sectionWrapper);
    });
  });

  function initTroubleshooting(sectionWrapper) {
    if (!sectionWrapper) return;

    function updateUnderlinePosition() {
      var activeTab = sectionWrapper.querySelector('.troubleshooting__tab.active');
      var tabsContainer = sectionWrapper.querySelector('.troubleshooting__tabs');

      if (!activeTab || !tabsContainer) return;
      if (window.innerWidth <= 749) return;

      var tabRect = activeTab.getBoundingClientRect();
      var containerRect = tabsContainer.getBoundingClientRect();

      var extension = window.innerWidth <= 989 ? 15 : 20;

      var left = tabRect.left - containerRect.left - extension;
      var width = tabRect.width + (extension * 2);

      tabsContainer.style.setProperty('--underline-left', left + 'px');
      tabsContainer.style.setProperty('--underline-width', width + 'px');
    }

    function setupProductNavigation() {
      var tabs = sectionWrapper.querySelectorAll('.troubleshooting__tab');

      updateUnderlinePosition();

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var productKey = tab.dataset.productKey;
          switchProduct(productKey);
        });
      });

      window.addEventListener('resize', updateUnderlinePosition);
    }

    function switchProduct(productKey) {
      sectionWrapper.querySelectorAll('.troubleshooting__tab').forEach(function(tab) {
        var isActive = tab.dataset.productKey === productKey;
        tab.classList.toggle('active', isActive);
        tab.setAttribute('aria-pressed', isActive);
      });

      updateUnderlinePosition();

      sectionWrapper.querySelectorAll('.troubleshooting__product').forEach(function(product) {
        var isActive = product.dataset.productKey === productKey;
        product.classList.toggle('active', isActive);
      });

      var activeProduct = sectionWrapper.querySelector('.troubleshooting__product[data-product-key="' + productKey + '"]');
      if (activeProduct) {
        var openItems = activeProduct.querySelectorAll('.troubleshooting__item.active');
        openItems.forEach(function(item) {
          item.classList.remove('active');
          var button = item.querySelector('.troubleshooting__question');
          if (button) {
            button.setAttribute('aria-expanded', 'false');
          }
        });
      }
    }

    function setupAccordions() {
      var accordions = sectionWrapper.querySelectorAll('.troubleshooting__item');

      accordions.forEach(function(accordion) {
        var toggle = accordion.querySelector('.troubleshooting__question');

        if (toggle) {
          toggle.addEventListener('click', function() {
            var product = accordion.closest('.troubleshooting__product');
            var isActive = accordion.classList.contains('active');

            requestAnimationFrame(function() {
              product.querySelectorAll('.troubleshooting__item').forEach(function(item) {
                item.classList.remove('active');
                var itemButton = item.querySelector('.troubleshooting__question');
                if (itemButton) {
                  itemButton.setAttribute('aria-expanded', 'false');
                }
              });

              if (!isActive) {
                accordion.classList.add('active');
                toggle.setAttribute('aria-expanded', 'true');
              }
            });
          });
        }
      });
    }

    setupProductNavigation();
    setupAccordions();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-benefits"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.video-benefits');

    sections.forEach(section => {
      initVideoBenefits(section);
    });
  });

  function initVideoBenefits(section) {
    if (!section) return;

    const accordions = section.querySelectorAll('.video-benefits__accordion');

    accordions.forEach(accordion => {
      const toggle = accordion.querySelector('.video-benefits__accordion-toggle');

      if (toggle) {
        toggle.addEventListener('click', () => {
          const isActive = accordion.classList.contains('active');

          // Use requestAnimationFrame to ensure simultaneous transitions
          requestAnimationFrame(() => {
            // Close all accordions in this section
            accordions.forEach(acc => {
              acc.classList.remove('active');
            });

            // Open clicked accordion if it wasn't active
            if (!isActive) {
              accordion.classList.add('active');
            }
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warranty-policy"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.warranty-policy');
    if (!section) return;

    var tabs = section.querySelectorAll('.warranty-policy__tab');
    var panels = section.querySelectorAll('.warranty-policy__panel');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var targetId = tab.getAttribute('data-tab');

        tabs.forEach(function(t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });

        panels.forEach(function(p) {
          p.classList.remove('is-active');
          p.setAttribute('aria-hidden', 'true');
          p.hidden = true;
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        var panel = section.querySelector('#warranty-tab-panel-' + targetId);
        if (panel) {
          panel.classList.add('is-active');
          panel.setAttribute('aria-hidden', 'false');
          panel.hidden = false;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warranty-registration"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var addBtn = document.getElementById('warranty-add-product');
    var productsContainer = document.getElementById('warranty-products');
    if (!addBtn || !productsContainer) return;

    var count = 1;

    addBtn.addEventListener('click', function() {
      count++;
      var row = document.createElement('div');
      row.className = 'warranty-registration__product-row';

      var field = document.createElement('div');
      field.className = 'field';

      var id = 'WarrantyForm-product-' + count;

      var input = document.createElement('input');
      input.className = 'field__input';
      input.type = 'text';
      input.id = id;
      input.name = 'contact[Product ' + count + ']';
      input.placeholder = 'Product name';

      var label = document.createElement('label');
      label.className = 'field__label';
      label.setAttribute('for', id);
      label.textContent = 'Product Name';

      field.appendChild(input);
      field.appendChild(label);
      row.appendChild(field);
      productsContainer.appendChild(row);

      input.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-choose-us"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const features = document.querySelectorAll('.why-choose-us__feature');
    const button = document.querySelector('.why-choose-us__button-wrapper');

    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    features.forEach(feature => {
      observer.observe(feature);
    });

    if (button) {
      observer.observe(button);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
